import { HttpErrorResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { CarsWidget } from '@com-delta-idp/mnx-sitewide-header-ui';
import {
  AirportSearchErrorService,
  HeaderFooterMachCore,
  HeaderFooterMachCoreContentService,
  LoggingService
} from '@com-delta-idp/mnx-sitewide-shared-core-smart';
import { BehaviorSubject, EMPTY, Observable } from 'rxjs';
import { catchError, take } from 'rxjs/operators';
import { BookingCarsAdapterService } from '../../adapters/booking-cars/booking-cars-adapter.service';
import { CarsLocationItem } from '../../models/interface/booking-cars/booking-cars.interfaces';
import { BookingCarsApiService } from '../../services/booking-cars/booking-cars-api.service';
import { BookingCarsFormService } from '../../utils/booking-cars/booking-cars-form.service';

@Injectable({ providedIn: 'root' })
export class BookingCarsFacadeService {
  adapter = inject(BookingCarsAdapterService);
  formService = inject(BookingCarsFormService);
  content = inject(HeaderFooterMachCoreContentService);
  loggingService = inject(LoggingService);
  apiService = inject(BookingCarsApiService);
  airportSearchErrorService = inject(AirportSearchErrorService);

  carsWidgetContent$ = new BehaviorSubject<CarsWidget>({} as CarsWidget);
  carsWidgetForm!: FormGroup;

  init(callback?: (success: boolean) => void): void {
    this.carsWidgetForm = this.formService.createBookingForm();

    this.content
      .getHeaderFooterMachCoreContent$()
      .pipe(
        take(1),
        catchError((error: HttpErrorResponse) => {
          this.loggingService.log(`AEM API failed: ${error.message}`);
          callback?.(false);
          return EMPTY;
        })
      )
      .subscribe((aem: HeaderFooterMachCore) => {
        if (aem?.header?.book.cars) {
          const errorMsg =
            aem?.header?.book.cars?.error?.predictiveCitiesNoResults || '';
          this.airportSearchErrorService.setErrorMessageFromAEM(errorMsg);
          this.carsWidgetContent$.next(this.adapter.getContent(aem));
          callback?.(true);
        } else {
          this.adapter.errorBannerMessage =
            aem?.header?.book.cars?.errorBannerMessage || '';
          callback?.(false);
        }
      });
  }

  searchLocations(query: string): Observable<CarsLocationItem[]> {
    return this.apiService.searchLocations(query);
  }

  formSubmitted(airportCode: string, gaiaId: string): void {
    const formValues = this.carsWidgetForm.getRawValue();
    this.formService.navigateToCarsSearch(formValues, airportCode, gaiaId);
  }

  reset(): void {
    this.carsWidgetForm = this.formService.createBookingForm();
  }
}
